<template>
  <twenty-four-hour :id="id" :rule="rule"></twenty-four-hour>
</template>
<script>
import twentyFourHour from "./twenty-four-hour.vue";
import { shareChargeRuleOne } from "@/api/url";
export default {
  data() {
    return {
      id: "",
      rule:{}
    };
  },
  components: { twentyFourHour },
  mounted() {
    const id = this.$route.query?.id ?? "";
   
    if (id) {
      this.getShareChargeRuleOne(id);
      this.id = id;
    }
  },
  methods: {
    getShareChargeRuleOne(id) {
      this.$get(`${shareChargeRuleOne()}/${id}`,{id}).then((res) => {
        this.rule=res?.data??{}
      });
    },
  },
};
</script>
<style lang="scss" scoped></style>
